"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_maxMessagePacketSize = 100e6;
//# sourceMappingURL=defaultSettings.js.map